import {
  IconMenuHome,
  IconSparkles,
  IconAnalyticsCreateVis,
  IconArrowToRight,
  IconPageHelpCenter,
  IconAnalyticsDashboard,
  IconAnalyticsVisualisation,
  IconBell,
  SideNavigationV2,
  IconChevronsRight,
  IconChevronsLeft,
} from '@intellihr/blueberry'
import { useLocation } from 'react-router-dom'
import { getCdnUrl } from '../../services/cdnAssets/helper'
import { HF_ANALYTICS_LOGO_DARK_BACKGROUND_PATH, HF_ANALYTICS_LOGO_HUMANFORCE_MONOGRAM_PATH } from '../../constants'

interface ILocalSideNavigationProps {
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
}

const LocalSideNavigation: React.FC<ILocalSideNavigationProps> = ({ collapsed, setCollapsed }) => {
  const { pathname } = useLocation()

  return (
    <>
      <SideNavigationV2
        collapsed={collapsed}
        collapsedLogo={getCdnUrl(HF_ANALYTICS_LOGO_HUMANFORCE_MONOGRAM_PATH)}
        testId="local-side-navigation"
        logo={getCdnUrl(HF_ANALYTICS_LOGO_DARK_BACKGROUND_PATH)}
        items={[
          {
            id: 'home',
            type: 'link',
            label: 'Home',
            accentColor: 'red',
            icon: <IconMenuHome />,
            href: '/',
            active: pathname === '/',
          },
          {
            id: 'ask-ai',
            type: 'link',
            label: 'Ask AI',
            accentColor: 'purple',
            icon: <IconSparkles />,
            href: '/ask-ai',
            active: pathname === '/ask-ai',
          },
          {
            id: 'dashboards',
            type: 'link',
            label: 'Dashboards',
            accentColor: 'red',
            icon: <IconAnalyticsDashboard />,
            href: '/dashboards',
            active: pathname === '/dashboards',
          },
          {
            id: 'create-visual',
            type: 'link',
            label: 'Create a visual',
            accentColor: 'red',
            icon: <IconAnalyticsCreateVis />,
            href: '/create-visual',
            active: pathname === '/create-visual',
          },
          {
            id: 'visualisations',
            type: 'link',
            label: 'Visualisations',
            accentColor: 'red',
            icon: <IconAnalyticsVisualisation />,
            href: '/visualisations',
            active: pathname === '/visualisations',
          },
          {
            id: 'subscriptions',
            type: 'link',
            label: 'Subscriptions',
            accentColor: 'red',
            icon: <IconBell />,
            href: '/subscriptions',
            active: pathname === '/subscriptions',
          },
        ]}
        secondaryItems={[
          {
            id: 'collapser',
            type: 'button',
            accentColor: 'red',
            icon: collapsed ? <IconChevronsRight /> : <IconChevronsLeft />,
            onClick: () => setCollapsed(!collapsed),
            label: collapsed ? 'Expand menu' : 'Hide menu',
          },
          {
            id: 'help-centre',
            type: 'link',
            label: 'Help Centre',
            icon: <IconPageHelpCenter />,
            href: 'https://help.humanforce.com/hc/en-au/categories/11948112319887-Intelligence',
            openNewTab: true,
            accentColor: 'red',
          },
          {
            id: 'logout',
            type: 'link',
            label: 'Logout',
            accentColor: 'red',
            icon: <IconArrowToRight />,
            href: '/logout',
          },
        ]}
      />
    </>
  )
}

export default LocalSideNavigation
